// extracted by mini-css-extract-plugin
module.exports = {"menu":"PortfolioSidebar__menu___3fh7t","wrapper":"PortfolioSidebar__wrapper___QYXrc","open":"PortfolioSidebar__open___3mGuY","separator":"PortfolioSidebar__separator___1YrvT"};